// Keep in sync with sales-chat-experience-frontend/src/lib/coaching-unread.ts
const COACHING_SESSION_READY_STATUSES = new Set([
  'completed',
  'analyzing',
  'stitchingForPlayback',
]);

function isCoachingSessionReadyStatus(status: unknown): boolean {
  return (
    typeof status === 'string' && COACHING_SESSION_READY_STATUSES.has(status)
  );
}

function isCoachingSessionUnread(
  data: { status?: unknown; viewedByRep?: Record<string, boolean> },
  contactId: string,
): boolean {
  if (!contactId || !isCoachingSessionReadyStatus(data.status)) {
    return false;
  }

  return data.viewedByRep?.[contactId] !== true;
}

function countUnreadCoachingSessions(
  docs: Iterable<{ data: () => Record<string, unknown> }>,
  contactId: string,
): number {
  if (!contactId) {
    return 0;
  }

  let count = 0;

  for (const document of docs) {
    const data = document.data();
    if (
      isCoachingSessionUnread(
        {
          status: data.status,
          viewedByRep: data.viewedByRep as Record<string, boolean> | undefined,
        },
        contactId,
      )
    ) {
      count += 1;
    }
  }

  return count;
}

export {
  countUnreadCoachingSessions,
  isCoachingSessionReadyStatus,
  isCoachingSessionUnread,
};
